import { SvgIcon, Typography } from "@mui/material";
import styled from "styled-components";
import Box from "../Box";

export const CustomBoxContentLink = styled(Box)`
  display: flex;
  align-items: center;
`;
export const CustomTypography = styled(Typography)`
  textdecoration: underline;
  fontfamily: Inter, sans-serif;
  fontsize: 14px;
  fontweight: 400;
  display: inline-block;
`;
export const StyledFiberManualRecord = styled(SvgIcon)`
  margin-right: 8px;
  color: blue; /* Change color of the icon */
`;
export const CustomBoxTableOfContent = styled(Box)`
  max-height: 50vh;
  overflow-y: auto;
`;
